<template>
    <div class="app-grid" :class="`app-grid--${gridLayout} app-grid--${gridGap}`">
        <slot />
    </div>
</template>

<script>
import './app-grid-section.scss';

export default {
    name: 'AppGridSection',
    __editor: {
        fields: {
            gridLayout: {
                widget: 'select',
                values: ['2x1', '2x2'],
            },
            gridGap: {
                widget: 'select',
                values: ['20', '50'],
            },
        },
    },
    props: {
        gridLayout: {
            type: String,
            required: false,
            default: '2x2',
        },
        gridGap: {
            type: String,
            required: false,
            default: '50',
        },
    },
};
</script>
